import { useState } from "react";
import "../css/PopUpJetonAcces.css";
import { upload_siteweb } from "./Fonctions_Communications_API";

export default function AjoutSiteWeb({ afficherPopupSiteWeb, setAfficherPopupSiteWeb, establishment}) {
  
  
  const [showWelcomePopup, setShowWelcomePopup] = useState(false);
  const [nouveauSite, setNouveauSite] = useState("");
 
  const handleSaveSiteWeb = () => {
      if (nouveauSite.trim() !== "") {
        upload_siteweb(establishment, nouveauSite, setNouveauSite);
        setAfficherPopupSiteWeb(false)
        setShowWelcomePopup(true);
      }
    };

  if (!afficherPopupSiteWeb && !showWelcomePopup) return null;

  return (
    <>
      {afficherPopupSiteWeb && (
        <div className="jetonacces-overlay">
          <div className="jetonacces-container">
            <h2 className="jetonacces-title">Ajouter un site web pour l'établissement {establishment.rs}</h2>
            <input
              type="text"
              placeholder="Entrez l'url du site web de l'établissement"
              value={nouveauSite}
              onChange={(e) => setNouveauSite(e.target.value)}
              className="jetonacces-input"
            />
            <div className="jetonacces-boutons">
              <button onClick={() => setAfficherPopupSiteWeb(false)} className="jetonacces-bouton cancel">Annuler</button>
              <button onClick={handleSaveSiteWeb} className="jetonacces-bouton submit">Valider</button>
            </div>
          </div>
        </div>
      )}

      {showWelcomePopup && (
        <div className="welcome-overlay">
          <div className="welcome-container">
            <h2 className="welcome-title">Merci beaucoup pour votre aide</h2>
            <p style={{fontFamily:'Interfont', color:"#190b34", fontStyle:'italic'}}>Nous vous remercions d'avoir ajouté le site web de cet établissement, ce pourrait être utile à de nombreux utilisateurs.</p>
            <button onClick={() => {setShowWelcomePopup(false)}} className="welcome-bouton">Fermer</button>
          </div>
        </div>
      )}
    </>
  );
}